/**
 * SVG `<defs>` block for the MC_00 capability ring. Ported from
 * `_legacy/mc.html` lines 1495-1537 and themed to follow the cascade
 * — gradient stops use `hsl(var(--accent-x-hsl) / alpha)` rather than
 * hardcoded hex+alpha, so the bubble fills swap when the theme toggles.
 *
 * Vanilla baked the alpha into 8-digit hex (e.g. `#FFC98222` = peach
 * at 13 % opacity) and relied on a runtime DOM rewriter
 * (`_applyBubbleThemeAttributes`) to swap dark-mode hex for light-mode
 * hex on every page load. The CSS-variable approach below kills that
 * scan entirely.
 */
export function MissionControlDefs() {
  return (
    <defs>
      {/* c1 / accent peach */}
      <radialGradient id="bYellow00" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="hsl(var(--accent-peach-hsl) / 0.13)" />
        <stop offset="100%" stopColor="hsl(var(--accent-peach-hsl) / 0.02)" />
      </radialGradient>

      {/* c2 / accent gold */}
      <radialGradient id="bOrange00" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="hsl(var(--accent-gold-hsl) / 0.13)" />
        <stop offset="100%" stopColor="hsl(var(--accent-gold-hsl) / 0.02)" />
      </radialGradient>

      {/* c3 / accent melon */}
      <radialGradient id="bMelon00" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="hsl(var(--accent-melon-hsl) / 0.09)" />
        <stop offset="100%" stopColor="hsl(var(--accent-melon-hsl) / 0.02)" />
      </radialGradient>

      {/* c4 / accent sky */}
      <radialGradient id="bBlue00" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="hsl(var(--accent-sky-hsl) / 0.13)" />
        <stop offset="100%" stopColor="hsl(var(--accent-sky-hsl) / 0.02)" />
      </radialGradient>

      {/* c5 / accent true-blue */}
      <radialGradient id="bCyan00" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="hsl(var(--accent-true-blue-hsl) / 0.13)" />
        <stop offset="100%" stopColor="hsl(var(--accent-true-blue-hsl) / 0.02)" />
      </radialGradient>

      {/* c6 / brand purple (no DXC token — keep as hex for now) */}
      <radialGradient id="bMelonAlt00" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#B081F118" />
        <stop offset="100%" stopColor="#B081F104" />
      </radialGradient>

      <filter id="glow00" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2.5" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
  );
}
